import type { TCond } from '$lib/common';
import type { TEvent } from '$lib/services/cometd/cometd.types';
import type { TEventConverterPayloads } from './eventConverter.types';
import { createEventConverter } from './createEventConverter';
import {
    walletEventConverterConfigs,
    jackpotEventConverterConfigs,
    playerValuablesEventConverterConfig,
    adventurerValuablesEventConverterConfig,
    mandatoryMessagesEventConverterConfigs,
    sessionConfigurationEventConverterConfigs,
    gameSessionNetFinancialPositionUpdatedConverterConfigs,
    umoboardEventConverterConfigs,
    realityCheckEventConverterConfigs,
    sessionEventConverterConfigs,
    persistentNotificationsEventConverterConfigs,
    kycEventConverterConfigs,
    depositLimitAdjustmentEventConverterConfig,
    sportsEventsConverterConfig
} from './eventConverterConfig';

export const getWalletEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    walletEventConverterConfigs.map((config) => createEventConverter(config));

export const getJackpotsEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    jackpotEventConverterConfigs.map((config) => createEventConverter(config));

export const getPlayerValuablesConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    playerValuablesEventConverterConfig.map((config) => createEventConverter(config));

export const getAdventurerValuablesConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    adventurerValuablesEventConverterConfig.map((config) => createEventConverter(config));

export const getMandatoryMessagesEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    mandatoryMessagesEventConverterConfigs.map((config) => createEventConverter(config));

export const getSessionConfigurationEventConverters = (): TCond<
    TEvent,
    TEventConverterPayloads
>[] => sessionConfigurationEventConverterConfigs.map((config) => createEventConverter(config));

export const getGameSessionNetFinancialPositionConverters = (): TCond<
    TEvent,
    TEventConverterPayloads
>[] =>
    gameSessionNetFinancialPositionUpdatedConverterConfigs.map((config) =>
        createEventConverter(config)
    );

export const getUmoboardEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    umoboardEventConverterConfigs.map((config) => createEventConverter(config));

export const getRealityCheckEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    realityCheckEventConverterConfigs.map((config) => createEventConverter(config));

export const getSessionEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    sessionEventConverterConfigs.map((config) => createEventConverter(config));

export const getPersistentNotificationsEventConverters = (): TCond<
    TEvent,
    TEventConverterPayloads
>[] => persistentNotificationsEventConverterConfigs.map((config) => createEventConverter(config));

export const getKycEventConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    kycEventConverterConfigs.map((config) => createEventConverter(config));

export const getDepositLimitAdjustmentEventConverters = (): TCond<
    TEvent,
    TEventConverterPayloads
>[] => depositLimitAdjustmentEventConverterConfig.map((config) => createEventConverter(config));

export const getSportsEventsConverters = (): TCond<TEvent, TEventConverterPayloads>[] =>
    sportsEventsConverterConfig.map((config) => createEventConverter(config));
